/**
 * Copyright IBM Corp. 2016, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { i as iconPropTypes, _ as _objectWithoutProperties, I as Icon, a as _objectSpread2 } from '../iconPropTypes-44033017.js';
import React from 'react';
import '@carbon/icon-helpers';
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle, _path31, _circle2, _path32, _path33, _circle3, _path34, _circle4, _path35, _path36, _path37, _circle5, _path38, _circle6, _path39, _path40, _circle7, _path41, _circle8, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _circle9, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _circle10, _circle11, _circle12, _circle13, _circle14, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _circle15, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _circle16, _path97, _path98, _path99, _path100, _circle17, _circle18, _path101, _path102, _circle19, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _circle27, _circle28, _circle29, _circle30, _circle31, _path125, _path126, _path127, _path128, _path129, _path130, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _path131, _path132, _circle38, _circle39, _circle40, _circle41, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _circle42, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _circle43, _circle44, _circle45, _path187, _path188;
var _excluded = ["children", "size"],
  _excluded2 = ["children", "size"],
  _excluded3 = ["children", "size"],
  _excluded4 = ["children", "size"],
  _excluded5 = ["children", "size"],
  _excluded6 = ["children", "size"],
  _excluded7 = ["children", "size"],
  _excluded8 = ["children", "size"],
  _excluded9 = ["children", "size"],
  _excluded10 = ["children", "size"],
  _excluded11 = ["children", "size"],
  _excluded12 = ["children", "size"],
  _excluded13 = ["children", "size"],
  _excluded14 = ["children", "size"],
  _excluded15 = ["children", "size"],
  _excluded16 = ["children", "size"],
  _excluded17 = ["children", "size"],
  _excluded18 = ["children", "size"],
  _excluded19 = ["children", "size"],
  _excluded20 = ["children", "size"],
  _excluded21 = ["children", "size"],
  _excluded22 = ["children", "size"],
  _excluded23 = ["children", "size"],
  _excluded24 = ["children", "size"],
  _excluded25 = ["children", "size"],
  _excluded26 = ["children", "size"],
  _excluded27 = ["children", "size"],
  _excluded28 = ["children", "size"],
  _excluded29 = ["children", "size"],
  _excluded30 = ["children", "size"],
  _excluded31 = ["children", "size"],
  _excluded32 = ["children", "size"],
  _excluded33 = ["children", "size"],
  _excluded34 = ["children", "size"],
  _excluded35 = ["children", "size"],
  _excluded36 = ["children", "size"],
  _excluded37 = ["children", "size"],
  _excluded38 = ["children", "size"],
  _excluded39 = ["children", "size"],
  _excluded40 = ["children", "size"],
  _excluded41 = ["children", "size"],
  _excluded42 = ["children", "size"],
  _excluded43 = ["children", "size"],
  _excluded44 = ["children", "size"],
  _excluded45 = ["children", "size"],
  _excluded46 = ["children", "size"],
  _excluded47 = ["children", "size"],
  _excluded48 = ["children", "size"],
  _excluded49 = ["children", "size"],
  _excluded50 = ["children", "size"],
  _excluded51 = ["children", "size"],
  _excluded52 = ["children", "size"],
  _excluded53 = ["children", "size"],
  _excluded54 = ["children", "size"],
  _excluded55 = ["children", "size"],
  _excluded56 = ["children", "size"],
  _excluded57 = ["children", "size"],
  _excluded58 = ["children", "size"],
  _excluded59 = ["children", "size"],
  _excluded60 = ["children", "size"],
  _excluded61 = ["children", "size"],
  _excluded62 = ["children", "size"],
  _excluded63 = ["children", "size"],
  _excluded64 = ["children", "size"],
  _excluded65 = ["children", "size"],
  _excluded66 = ["children", "size"],
  _excluded67 = ["children", "size"],
  _excluded68 = ["children", "size"],
  _excluded69 = ["children", "size"],
  _excluded70 = ["children", "size"],
  _excluded71 = ["children", "size"],
  _excluded72 = ["children", "size"],
  _excluded73 = ["children", "size"],
  _excluded74 = ["children", "size"],
  _excluded75 = ["children", "size"],
  _excluded76 = ["children", "size"],
  _excluded77 = ["children", "size"],
  _excluded78 = ["children", "size"],
  _excluded79 = ["children", "size"],
  _excluded80 = ["children", "size"],
  _excluded81 = ["children", "size"],
  _excluded82 = ["children", "size"],
  _excluded83 = ["children", "size"],
  _excluded84 = ["children", "size"],
  _excluded85 = ["children", "size"],
  _excluded86 = ["children", "size"],
  _excluded87 = ["children", "size"],
  _excluded88 = ["children", "size"],
  _excluded89 = ["children", "size"],
  _excluded90 = ["children", "size"],
  _excluded91 = ["children", "size"],
  _excluded92 = ["children", "size"],
  _excluded93 = ["children", "size"],
  _excluded94 = ["children", "size"],
  _excluded95 = ["children", "size"],
  _excluded96 = ["children", "size"],
  _excluded97 = ["children", "size"],
  _excluded98 = ["children", "size"],
  _excluded99 = ["children", "size"],
  _excluded100 = ["children", "size"],
  _excluded101 = ["children", "size"],
  _excluded102 = ["children", "size"],
  _excluded103 = ["children", "size"],
  _excluded104 = ["children", "size"],
  _excluded105 = ["children", "size"],
  _excluded106 = ["children", "size"],
  _excluded107 = ["children", "size"],
  _excluded108 = ["children", "size"],
  _excluded109 = ["children", "size"],
  _excluded110 = ["children", "size"],
  _excluded111 = ["children", "size"],
  _excluded112 = ["children", "size"],
  _excluded113 = ["children", "size"],
  _excluded114 = ["children", "size"],
  _excluded115 = ["children", "size"],
  _excluded116 = ["children", "size"],
  _excluded117 = ["children", "size"],
  _excluded118 = ["children", "size"],
  _excluded119 = ["children", "size"],
  _excluded120 = ["children", "size"],
  _excluded121 = ["children", "size"],
  _excluded122 = ["children", "size"],
  _excluded123 = ["children", "size"],
  _excluded124 = ["children", "size"],
  _excluded125 = ["children", "size"];
var ClosedCaption = /*#__PURE__*/React.forwardRef(function ClosedCaption(_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ClosedCaptionAlt = /*#__PURE__*/React.forwardRef(function ClosedCaptionAlt(_ref2, ref) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 16 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ClosedCaptionFilled = /*#__PURE__*/React.forwardRef(function ClosedCaptionFilled(_ref3, ref) {
  var children = _ref3.children,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 16 : _ref3$size,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cloud = /*#__PURE__*/React.forwardRef(function Cloud(_ref4, ref) {
  var children = _ref4.children,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 16 : _ref4$size,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudAlerting = /*#__PURE__*/React.forwardRef(function CloudAlerting(_ref5, ref) {
  var children = _ref5.children,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 16 : _ref5$size,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudAuditing = /*#__PURE__*/React.forwardRef(function CloudAuditing(_ref6, ref) {
  var children = _ref6.children,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 16 : _ref6$size,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudDataOps = /*#__PURE__*/React.forwardRef(function CloudDataOps(_ref7, ref) {
  var children = _ref7.children,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 16 : _ref7$size,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudDownload = /*#__PURE__*/React.forwardRef(function CloudDownload(_ref8, ref) {
  var children = _ref8.children,
    _ref8$size = _ref8.size,
    size = _ref8$size === void 0 ? 16 : _ref8$size,
    rest = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudLogging = /*#__PURE__*/React.forwardRef(function CloudLogging(_ref9, ref) {
  var children = _ref9.children,
    _ref9$size = _ref9.size,
    size = _ref9$size === void 0 ? 16 : _ref9$size,
    rest = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H30V10H18zM18 12H24V14H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudMonitoring = /*#__PURE__*/React.forwardRef(function CloudMonitoring(_ref10, ref) {
  var children = _ref10.children,
    _ref10$size = _ref10.size,
    size = _ref10$size === void 0 ? 16 : _ref10$size,
    rest = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudOffline = /*#__PURE__*/React.forwardRef(function CloudOffline(_ref11, ref) {
  var children = _ref11.children,
    _ref11$size = _ref11.size,
    size = _ref11$size === void 0 ? 16 : _ref11$size,
    rest = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudServiceManagement = /*#__PURE__*/React.forwardRef(function CloudServiceManagement(_ref12, ref) {
  var children = _ref12.children,
    _ref12$size = _ref12.size,
    size = _ref12$size === void 0 ? 16 : _ref12$size,
    rest = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudUpload = /*#__PURE__*/React.forwardRef(function CloudUpload(_ref13, ref) {
  var children = _ref13.children,
    _ref13$size = _ref13.size,
    size = _ref13$size === void 0 ? 16 : _ref13$size,
    rest = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudApp = /*#__PURE__*/React.forwardRef(function CloudApp(_ref14, ref) {
  var children = _ref14.children,
    _ref14$size = _ref14.size,
    size = _ref14$size === void 0 ? 16 : _ref14$size,
    rest = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudCeiling = /*#__PURE__*/React.forwardRef(function CloudCeiling(_ref15, ref) {
  var children = _ref15.children,
    _ref15$size = _ref15.size,
    size = _ref15$size === void 0 ? 16 : _ref15$size,
    rest = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudFoundry_1 = /*#__PURE__*/React.forwardRef(function CloudFoundry_1(_ref16, ref) {
  var children = _ref16.children,
    _ref16$size = _ref16.size,
    size = _ref16$size === void 0 ? 16 : _ref16$size,
    rest = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudFoundry_2 = /*#__PURE__*/React.forwardRef(function CloudFoundry_2(_ref17, ref) {
  var children = _ref17.children,
    _ref17$size = _ref17.size,
    size = _ref17$size === void 0 ? 16 : _ref17$size,
    rest = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudRegistry = /*#__PURE__*/React.forwardRef(function CloudRegistry(_ref18, ref) {
  var children = _ref18.children,
    _ref18$size = _ref18.size,
    size = _ref18$size === void 0 ? 16 : _ref18$size,
    rest = _objectWithoutProperties(_ref18, _excluded18);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudSatellite = /*#__PURE__*/React.forwardRef(function CloudSatellite(_ref19, ref) {
  var children = _ref19.children,
    _ref19$size = _ref19.size,
    size = _ref19$size === void 0 ? 16 : _ref19$size,
    rest = _objectWithoutProperties(_ref19, _excluded19);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudSatelliteConfig = /*#__PURE__*/React.forwardRef(function CloudSatelliteConfig(_ref20, ref) {
  var children = _ref20.children,
    _ref20$size = _ref20.size,
    size = _ref20$size === void 0 ? 16 : _ref20$size,
    rest = _objectWithoutProperties(_ref20, _excluded20);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudSatelliteLink = /*#__PURE__*/React.forwardRef(function CloudSatelliteLink(_ref21, ref) {
  var children = _ref21.children,
    _ref21$size = _ref21.size,
    size = _ref21$size === void 0 ? 16 : _ref21$size,
    rest = _objectWithoutProperties(_ref21, _excluded21);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudSatelliteServices = /*#__PURE__*/React.forwardRef(function CloudSatelliteServices(_ref22, ref) {
  var children = _ref22.children,
    _ref22$size = _ref22.size,
    size = _ref22$size === void 0 ? 16 : _ref22$size,
    rest = _objectWithoutProperties(_ref22, _excluded22);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CloudServices = /*#__PURE__*/React.forwardRef(function CloudServices(_ref23, ref) {
  var children = _ref23.children,
    _ref23$size = _ref23.size,
    size = _ref23$size === void 0 ? 16 : _ref23$size,
    rest = _objectWithoutProperties(_ref23, _excluded23);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cloudy = /*#__PURE__*/React.forwardRef(function Cloudy(_ref24, ref) {
  var children = _ref24.children,
    _ref24$size = _ref24.size,
    size = _ref24$size === void 0 ? 16 : _ref24$size,
    rest = _objectWithoutProperties(_ref24, _excluded24);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCobbAngle = /*#__PURE__*/React.forwardRef(function WatsonHealthCobbAngle(_ref25, ref) {
  var children = _ref25.children,
    _ref25$size = _ref25.size,
    size = _ref25$size === void 0 ? 16 : _ref25$size,
    rest = _objectWithoutProperties(_ref25, _excluded25);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Code = /*#__PURE__*/React.forwardRef(function Code(_ref26, ref) {
  var children = _ref26.children,
    _ref26$size = _ref26.size,
    size = _ref26$size === void 0 ? 16 : _ref26$size,
    rest = _objectWithoutProperties(_ref26, _excluded26);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CodeHide = /*#__PURE__*/React.forwardRef(function CodeHide(_ref27, ref) {
  var children = _ref27.children,
    _ref27$size = _ref27.size,
    size = _ref27$size === void 0 ? 16 : _ref27$size,
    rest = _objectWithoutProperties(_ref27, _excluded27);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CodeReference = /*#__PURE__*/React.forwardRef(function CodeReference(_ref28, ref) {
  var children = _ref28.children,
    _ref28$size = _ref28.size,
    size = _ref28$size === void 0 ? 16 : _ref28$size,
    rest = _objectWithoutProperties(_ref28, _excluded28);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CodeSigningService = /*#__PURE__*/React.forwardRef(function CodeSigningService(_ref29, ref) {
  var children = _ref29.children,
    _ref29$size = _ref29.size,
    size = _ref29$size === void 0 ? 16 : _ref29$size,
    rest = _objectWithoutProperties(_ref29, _excluded29);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cognitive = /*#__PURE__*/React.forwardRef(function Cognitive(_ref30, ref) {
  var children = _ref30.children,
    _ref30$size = _ref30.size,
    size = _ref30$size === void 0 ? 16 : _ref30$size,
    rest = _objectWithoutProperties(_ref30, _excluded30);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Collaborate = /*#__PURE__*/React.forwardRef(function Collaborate(_ref31, ref) {
  var children = _ref31.children,
    _ref31$size = _ref31.size,
    size = _ref31$size === void 0 ? 16 : _ref31$size,
    rest = _objectWithoutProperties(_ref31, _excluded31);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CollapseAll = /*#__PURE__*/React.forwardRef(function CollapseAll(_ref32, ref) {
  var children = _ref32.children,
    _ref32$size = _ref32.size,
    size = _ref32$size === void 0 ? 16 : _ref32$size,
    rest = _objectWithoutProperties(_ref32, _excluded32);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CollapseCategories = /*#__PURE__*/React.forwardRef(function CollapseCategories(_ref33, ref) {
  var children = _ref33.children,
    _ref33$size = _ref33.size,
    size = _ref33$size === void 0 ? 16 : _ref33$size,
    rest = _objectWithoutProperties(_ref33, _excluded33);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ColorPalette = /*#__PURE__*/React.forwardRef(function ColorPalette(_ref34, ref) {
  var children = _ref34.children,
    _ref34$size = _ref34.size,
    size = _ref34$size === void 0 ? 16 : _ref34$size,
    rest = _objectWithoutProperties(_ref34, _excluded34);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "12",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "18",
    r: "2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "23",
    r: "2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ColorSwitch = /*#__PURE__*/React.forwardRef(function ColorSwitch(_ref35, ref) {
  var children = _ref35.children,
    _ref35$size = _ref35.size,
    size = _ref35$size === void 0 ? 16 : _ref35$size,
    rest = _objectWithoutProperties(_ref35, _excluded35);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Column = /*#__PURE__*/React.forwardRef(function Column(_ref36, ref) {
  var children = _ref36.children,
    _ref36$size = _ref36.size,
    size = _ref36$size === void 0 ? 16 : _ref36$size,
    rest = _objectWithoutProperties(_ref36, _excluded36);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ColumnDelete = /*#__PURE__*/React.forwardRef(function ColumnDelete(_ref37, ref) {
  var children = _ref37.children,
    _ref37$size = _ref37.size,
    size = _ref37$size === void 0 ? 16 : _ref37$size,
    rest = _objectWithoutProperties(_ref37, _excluded37);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ColumnInsert = /*#__PURE__*/React.forwardRef(function ColumnInsert(_ref38, ref) {
  var children = _ref38.children,
    _ref38$size = _ref38.size,
    size = _ref38$size === void 0 ? 16 : _ref38$size,
    rest = _objectWithoutProperties(_ref38, _excluded38);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ColumnDependency = /*#__PURE__*/React.forwardRef(function ColumnDependency(_ref39, ref) {
  var children = _ref39.children,
    _ref39$size = _ref39.size,
    size = _ref39$size === void 0 ? 16 : _ref39$size,
    rest = _objectWithoutProperties(_ref39, _excluded39);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Commit = /*#__PURE__*/React.forwardRef(function Commit(_ref40, ref) {
  var children = _ref40.children,
    _ref40$size = _ref40.size,
    size = _ref40$size === void 0 ? 16 : _ref40$size,
    rest = _objectWithoutProperties(_ref40, _excluded40);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CommunicationUnified = /*#__PURE__*/React.forwardRef(function CommunicationUnified(_ref41, ref) {
  var children = _ref41.children,
    _ref41$size = _ref41.size,
    size = _ref41$size === void 0 ? 16 : _ref41$size,
    rest = _objectWithoutProperties(_ref41, _excluded41);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Compare = /*#__PURE__*/React.forwardRef(function Compare(_ref42, ref) {
  var children = _ref42.children,
    _ref42$size = _ref42.size,
    size = _ref42$size === void 0 ? 16 : _ref42$size,
    rest = _objectWithoutProperties(_ref42, _excluded42);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Compass = /*#__PURE__*/React.forwardRef(function Compass(_ref43, ref) {
  var children = _ref43.children,
    _ref43$size = _ref43.size,
    size = _ref43$size === void 0 ? 16 : _ref43$size,
    rest = _objectWithoutProperties(_ref43, _excluded43);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7.5",
    r: "1.5"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QComposerEdit = /*#__PURE__*/React.forwardRef(function QComposerEdit(_ref44, ref) {
  var children = _ref44.children,
    _ref44$size = _ref44.size,
    size = _ref44$size === void 0 ? 16 : _ref44$size,
    rest = _objectWithoutProperties(_ref44, _excluded44);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Concept = /*#__PURE__*/React.forwardRef(function Concept(_ref45, ref) {
  var children = _ref45.children,
    _ref45$size = _ref45.size,
    size = _ref45$size === void 0 ? 16 : _ref45$size,
    rest = _objectWithoutProperties(_ref45, _excluded45);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConditionPoint = /*#__PURE__*/React.forwardRef(function ConditionPoint(_ref46, ref) {
  var children = _ref46.children,
    _ref46$size = _ref46.size,
    size = _ref46$size === void 0 ? 16 : _ref46$size,
    rest = _objectWithoutProperties(_ref46, _excluded46);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M10.343 10.343H21.657V21.657H10.343z",
    transform: "rotate(-45 16 16)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConditionWaitPoint = /*#__PURE__*/React.forwardRef(function ConditionWaitPoint(_ref47, ref) {
  var children = _ref47.children,
    _ref47$size = _ref47.size,
    size = _ref47$size === void 0 ? 16 : _ref47$size,
    rest = _objectWithoutProperties(_ref47, _excluded47);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.343 10.343H21.657V21.657H10.343z",
    transform: "rotate(-45 16 16)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Connect = /*#__PURE__*/React.forwardRef(function Connect(_ref48, ref) {
  var children = _ref48.children,
    _ref48$size = _ref48.size,
    size = _ref48$size === void 0 ? 16 : _ref48$size,
    rest = _objectWithoutProperties(_ref48, _excluded48);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
    transform: "translate(0 .01)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectRecursive = /*#__PURE__*/React.forwardRef(function ConnectRecursive(_ref49, ref) {
  var children = _ref49.children,
    _ref49$size = _ref49.size,
    size = _ref49$size === void 0 ? 16 : _ref49$size,
    rest = _objectWithoutProperties(_ref49, _excluded49);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectReference = /*#__PURE__*/React.forwardRef(function ConnectReference(_ref50, ref) {
  var children = _ref50.children,
    _ref50$size = _ref50.size,
    size = _ref50$size === void 0 ? 16 : _ref50$size,
    rest = _objectWithoutProperties(_ref50, _excluded50);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectSource = /*#__PURE__*/React.forwardRef(function ConnectSource(_ref51, ref) {
  var children = _ref51.children,
    _ref51$size = _ref51.size,
    size = _ref51$size === void 0 ? 16 : _ref51$size,
    rest = _objectWithoutProperties(_ref51, _excluded51);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectTarget = /*#__PURE__*/React.forwardRef(function ConnectTarget(_ref52, ref) {
  var children = _ref52.children,
    _ref52$size = _ref52.size,
    size = _ref52$size === void 0 ? 16 : _ref52$size,
    rest = _objectWithoutProperties(_ref52, _excluded52);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectionReceive = /*#__PURE__*/React.forwardRef(function ConnectionReceive(_ref53, ref) {
  var children = _ref53.children,
    _ref53$size = _ref53.size,
    size = _ref53$size === void 0 ? 16 : _ref53$size,
    rest = _objectWithoutProperties(_ref53, _excluded53);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectionSend = /*#__PURE__*/React.forwardRef(function ConnectionSend(_ref54, ref) {
  var children = _ref54.children,
    _ref54$size = _ref54.size,
    size = _ref54$size === void 0 ? 16 : _ref54$size,
    rest = _objectWithoutProperties(_ref54, _excluded54);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectionTwoWay = /*#__PURE__*/React.forwardRef(function ConnectionTwoWay(_ref55, ref) {
  var children = _ref55.children,
    _ref55$size = _ref55.size,
    size = _ref55$size === void 0 ? 16 : _ref55$size,
    rest = _objectWithoutProperties(_ref55, _excluded55);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectionSignal = /*#__PURE__*/React.forwardRef(function ConnectionSignal(_ref56, ref) {
  var children = _ref56.children,
    _ref56$size = _ref56.size,
    size = _ref56$size === void 0 ? 16 : _ref56$size,
    rest = _objectWithoutProperties(_ref56, _excluded56);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConnectionSignalOff = /*#__PURE__*/React.forwardRef(function ConnectionSignalOff(_ref57, ref) {
  var children = _ref57.children,
    _ref57$size = _ref57.size,
    size = _ref57$size === void 0 ? 16 : _ref57$size,
    rest = _objectWithoutProperties(_ref57, _excluded57);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Construction = /*#__PURE__*/React.forwardRef(function Construction(_ref58, ref) {
  var children = _ref58.children,
    _ref58$size = _ref58.size,
    size = _ref58$size === void 0 ? 16 : _ref58$size,
    rest = _objectWithoutProperties(_ref58, _excluded58);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContainerRegistry = /*#__PURE__*/React.forwardRef(function ContainerRegistry(_ref59, ref) {
  var children = _ref59.children,
    _ref59$size = _ref59.size,
    size = _ref59$size === void 0 ? 16 : _ref59$size,
    rest = _objectWithoutProperties(_ref59, _excluded59);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11H19V2h9zM21 9h5V4H21zM28 20H26v2h2v6H4V22H6V20H4a2.0024 2.0024 0 00-2 2v6a2.0024 2.0024 0 002 2H28a2.0024 2.0024 0 002-2V22A2.0024 2.0024 0 0028 20z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContainerServices = /*#__PURE__*/React.forwardRef(function ContainerServices(_ref60, ref) {
  var children = _ref60.children,
    _ref60$size = _ref60.size,
    size = _ref60$size === void 0 ? 16 : _ref60$size,
    rest = _objectWithoutProperties(_ref60, _excluded60);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22V17a2.0023,2.0023,0,0,0-2-2H17V10h3a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H12a2.0023,2.0023,0,0,0-2,2V8a2.0023,2.0023,0,0,0,2,2h3v5H7a2.0023,2.0023,0,0,0-2,2v5H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM12,4h8V8H12ZM8,28H4V24H8Zm10,0H14V24h4Zm10,0H24V24h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContainerSoftware = /*#__PURE__*/React.forwardRef(function ContainerSoftware(_ref61, ref) {
  var children = _ref61.children,
    _ref61$size = _ref61.size,
    size = _ref61$size === void 0 ? 16 : _ref61$size,
    rest = _objectWithoutProperties(_ref61, _excluded61);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H20V4h8Zm-6-2h4V6H22Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17,15V9H9V23H23V15Zm-6-4h4v4H11Zm4,10H11V17h4Zm6,0H17V17h4Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0023,2.0023,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContentDeliveryNetwork = /*#__PURE__*/React.forwardRef(function ContentDeliveryNetwork(_ref62, ref) {
  var children = _ref62.children,
    _ref62$size = _ref62.size,
    size = _ref62$size === void 0 ? 16 : _ref62$size,
    rest = _objectWithoutProperties(_ref62, _excluded62);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M27,31a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,27,31Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,27,25Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16A14.0412,14.0412,0,0,0,16,2,13.0426,13.0426,0,0,0,9.2,3.8l1.1,1.7a24.4254,24.4254,0,0,1,2.4-1A25.1349,25.1349,0,0,0,10,15H4a11.1489,11.1489,0,0,1,1.4-4.7L3.9,9A13.8418,13.8418,0,0,0,2,16,13.9983,13.9983,0,0,0,16,30a13.3656,13.3656,0,0,0,5.2-1l-.6-1.9a11.4416,11.4416,0,0,1-5.2.9h0A21.0713,21.0713,0,0,1,12,17H29.9A3.4019,3.4019,0,0,0,30,16ZM12.8,27.6h0a13.02,13.02,0,0,1-5.3-3.1A12.5053,12.5053,0,0,1,4,17h6A25.0022,25.0022,0,0,0,12.8,27.6ZM12,15A21.4461,21.4461,0,0,1,15.3,4h1.4A21.4461,21.4461,0,0,1,20,15Zm10,0A23.2777,23.2777,0,0,0,19.2,4.4,12.0919,12.0919,0,0,1,27.9,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContentView = /*#__PURE__*/React.forwardRef(function ContentView(_ref63, ref) {
  var children = _ref63.children,
    _ref63$size = _ref63.size,
    size = _ref63$size === void 0 ? 16 : _ref63$size,
    rest = _objectWithoutProperties(_ref63, _excluded63);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "19",
    r: "2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Continue = /*#__PURE__*/React.forwardRef(function Continue(_ref64, ref) {
  var children = _ref64.children,
    _ref64$size = _ref64.size,
    size = _ref64$size === void 0 ? 16 : _ref64$size,
    rest = _objectWithoutProperties(_ref64, _excluded64);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM11 6.7344V25.2656L27 16zM4 4H6V28H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContinueFilled = /*#__PURE__*/React.forwardRef(function ContinueFilled(_ref65, ref) {
  var children = _ref65.children,
    _ref65$size = _ref65.size,
    size = _ref65$size === void 0 ? 16 : _ref65$size,
    rest = _objectWithoutProperties(_ref65, _excluded65);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28a1 1 0 01-1-1V5a1 1 0 011.501-.8652l19 11a1 1 0 010 1.73l-19 11A.9975.9975 0 0110 28zM4 4H6V28H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContinuousDeployment = /*#__PURE__*/React.forwardRef(function ContinuousDeployment(_ref66, ref) {
  var children = _ref66.children,
    _ref66$size = _ref66.size,
    size = _ref66$size === void 0 ? 16 : _ref66$size,
    rest = _objectWithoutProperties(_ref66, _excluded66);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2l-6,6l1.4,1.4L23,5.8V19c0,5-4,9-9,9c-1.6,0-3.1-0.4-4.3-1.1C10.1,27,10.5,27,11,27c4.4,0,8-3.6,8-8s-3.6-8-8-8 s-8,3.6-8,8c0,6.1,4.9,11,11,11s11-4.9,11-11V5.8l3.6,3.6L30,8L24,2z M5,19.6c0-0.2,0-0.4,0-0.6c0-3.3,2.7-6,6-6s6,2.7,6,6 s-2.7,6-6,6C7.9,25,5.3,22.6,5,19.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ContinuousIntegration = /*#__PURE__*/React.forwardRef(function ContinuousIntegration(_ref67, ref) {
  var children = _ref67.children,
    _ref67$size = _ref67.size,
    size = _ref67$size === void 0 ? 16 : _ref67$size,
    rest = _objectWithoutProperties(_ref67, _excluded67);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9,15.5l-5.7-10C25.9,5.2,25.6,5,25.3,5H6.7C6.4,5,6.1,5.2,5.9,5.5l-5.7,10C0,15.7,0,15.8,0,16s0,0.3,0.1,0.5l5.7,10 C6.1,26.8,6.4,27,6.7,27h18.5c0.4,0,0.7-0.2,0.9-0.5l5.7-10C32,16.3,32,16.2,32,16S32,15.7,31.9,15.5z M17.8,15h-8l4-7L17.8,15z M15.5,7h8l-4,7L15.5,7z M17.8,17l-4,7l-4-7H17.8z M19.5,18l4,7h-8L19.5,18z M21.2,17h8l-4,7L21.2,17z M21.2,15l4-7l4,7H21.2z M7.3,7H12l-4.6,8H2.7L7.3,7z M7.3,25l-4.6-8h4.7l4.6,8H7.3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthContourDraw = /*#__PURE__*/React.forwardRef(function WatsonHealthContourDraw(_ref68, ref) {
  var children = _ref68.children,
    _ref68$size = _ref68.size,
    size = _ref68$size === void 0 ? 16 : _ref68$size,
    rest = _objectWithoutProperties(_ref68, _excluded68);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthContourEdit = /*#__PURE__*/React.forwardRef(function WatsonHealthContourEdit(_ref69, ref) {
  var children = _ref69.children,
    _ref69$size = _ref69.size,
    size = _ref69$size === void 0 ? 16 : _ref69$size,
    rest = _objectWithoutProperties(_ref69, _excluded69);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30V28A12.0021 12.0021 0 0019.6924 4.5786l.6152-1.9033A14.0022 14.0022 0 0116 30zM7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4023 24.248a11.9488 11.9488 0 00-1.7182-3.3354L15.2974 19.73a13.9486 13.9486 0 012.0044 3.893zM11.02 18.2668a11.9215 11.9215 0 00-3.3467-1.6943l.6114-1.9043a13.9242 13.9242 0 013.9072 1.978z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthContourFinding = /*#__PURE__*/React.forwardRef(function WatsonHealthContourFinding(_ref70, ref) {
  var children = _ref70.children,
    _ref70$size = _ref70.size,
    size = _ref70$size === void 0 ? 16 : _ref70$size,
    rest = _objectWithoutProperties(_ref70, _excluded70);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 4.7a14.7029 14.7029 0 00-3 3.1L6.3 9A13.2634 13.2634 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.5111 12.5111 0 002 16H4A11.4756 11.4756 0 014.6 12.3zM2.7 20.4a14.4029 14.4029 0 002 3.9l1.6-1.2a12.8867 12.8867 0 01-1.7-3.3zM7.8 27.3a14.4029 14.4029 0 003.9 2l.6-1.9A12.8867 12.8867 0 019 25.7zM11.7 2.7l.6 1.9A11.4756 11.4756 0 0116 4V2A12.5111 12.5111 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.526 11.526 0 0123 25.7zM27.4 19.7l1.9.6A15.4747 15.4747 0 0030 16H28A11.4756 11.4756 0 0127.4 19.7zM29.2 11.6a14.4029 14.4029 0 00-2-3.9L25.6 8.9a12.8867 12.8867 0 011.7 3.3zM24.1 4.6a14.4029 14.4029 0 00-3.9-2l-.6 1.9a12.8867 12.8867 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.4756 11.4756 0 0116 28v2A21.4206 21.4206 0 0020.3 29.3zM16 26A10 10 0 1126 16 10.0115 10.0115 0 0116 26zM16 8a8 8 0 108 8A8.0092 8.0092 0 0016 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Contrast = /*#__PURE__*/React.forwardRef(function Contrast(_ref71, ref) {
  var children = _ref71.children,
    _ref71$size = _ref71.size,
    size = _ref71$size === void 0 ? 16 : _ref71$size,
    rest = _objectWithoutProperties(_ref71, _excluded71);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37,11.84a13.6,13.6,0,0,0-1.06-2.51A14.17,14.17,0,0,0,25.9,6.1a14,14,0,1,0,0,19.8,14.17,14.17,0,0,0,2.41-3.23,13.6,13.6,0,0,0,1.06-2.51,14,14,0,0,0,0-8.32ZM4,16A12,12,0,0,1,16,4V28A12,12,0,0,1,4,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ConvertToCloud = /*#__PURE__*/React.forwardRef(function ConvertToCloud(_ref72, ref) {
  var children = _ref72.children,
    _ref72$size = _ref72.size,
    size = _ref72$size === void 0 ? 16 : _ref72$size,
    rest = _objectWithoutProperties(_ref72, _excluded72);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM23 14l-5 5 1.4141 1.4141L22 17.8325V24H16v2h6a2.0025 2.0025 0 002-2V17.8325l2.5874 2.583L28 19zM2 20H12V22H2zM2 24H12V26H2zM2 28H12V30H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cookie = /*#__PURE__*/React.forwardRef(function Cookie(_ref73, ref) {
  var children = _ref73.children,
    _ref73$size = _ref73.size,
    size = _ref73$size === void 0 ? 16 : _ref73$size,
    rest = _objectWithoutProperties(_ref73, _excluded73);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "21",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "20",
    r: "2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "10",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "15",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "5",
    r: "2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "3",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2c0.1,0,0.2,0,0.3,0l1.4,0.1l-0.3,1.2c-0.1,0.4-0.2,0.9-0.2,1.3c0,2.8,2.2,5,5,5 c1,0,2-0.3,2.9-0.9l1.3,1.5c-0.4,0.4-0.6,0.9-0.6,1.4c0,1.3,1.3,2.4,2.7,1.9l1.2-0.5l0.2,1.3C30,14.9,30,15.5,30,16 C30,23.7,23.7,30,16,30z M15.3,4C9,4.4,4,9.6,4,16c0,6.6,5.4,12,12,12s12-5.4,12-12c0-0.1,0-0.3,0-0.4c-2.3,0.1-4.2-1.7-4.2-4 c0-0.1,0-0.1,0-0.2c-0.5,0.1-1,0.2-1.6,0.2c-3.9,0-7-3.1-7-7C15.2,4.4,15.2,4.2,15.3,4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Copy = /*#__PURE__*/React.forwardRef(function Copy(_ref74, ref) {
  var children = _ref74.children,
    _ref74$size = _ref74.size,
    size = _ref74$size === void 0 ? 16 : _ref74$size,
    rest = _objectWithoutProperties(_ref74, _excluded74);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10V28H10V10H28m0-2H10a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18H2V4A2,2,0,0,1,4,2H18V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CopyFile = /*#__PURE__*/React.forwardRef(function CopyFile(_ref75, ref) {
  var children = _ref75.children,
    _ref75$size = _ref75.size,
    size = _ref75$size === void 0 ? 16 : _ref75$size,
    rest = _objectWithoutProperties(_ref75, _excluded75);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1 C28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CopyLink = /*#__PURE__*/React.forwardRef(function CopyLink(_ref76, ref) {
  var children = _ref76.children,
    _ref76$size = _ref76.size,
    size = _ref76$size === void 0 ? 16 : _ref76$size,
    rest = _objectWithoutProperties(_ref76, _excluded76);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9474,19a4.9476,4.9476,0,0,1-3.4991-8.4465l5.1053-5.1043a4.9482,4.9482,0,0,1,6.9981,6.9976l-.5523.5526-1.4158-1.4129.5577-.5579a2.95,2.95,0,0,0-.0039-4.1653,3.02,3.02,0,0,0-4.17,0l-5.1047,5.104a2.9474,2.9474,0,0,0,0,4.1692,3.02,3.02,0,0,0,4.17,0l1.4143,1.4145A4.9176,4.9176,0,0,1,11.9474,19Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9474,17a4.9476,4.9476,0,0,1-3.4991-8.4465l.5526-.5526,1.4143,1.4146-.5526.5523a2.9476,2.9476,0,0,0,0,4.1689,3.02,3.02,0,0,0,4.17,0c.26-.26,4.7293-4.7293,5.1053-5.1045a2.951,2.951,0,0,0,0-4.1687,3.02,3.02,0,0,0-4.17,0L21.5536,3.449a4.9483,4.9483,0,0,1,6.9981,6.9978c-.3765.376-4.844,4.8428-5.1038,5.1035A4.9193,4.9193,0,0,1,19.9474,17Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H4a2.0021,2.0021,0,0,1-2-2V8A2.0021,2.0021,0,0,1,4,6H8V8H4V28H24V18h2V28A2.0021,2.0021,0,0,1,24,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Corn = /*#__PURE__*/React.forwardRef(function Corn(_ref77, ref) {
  var children = _ref77.children,
    _ref77$size = _ref77.size,
    size = _ref77$size === void 0 ? 16 : _ref77$size,
    rest = _objectWithoutProperties(_ref77, _excluded77);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16c-.3374,0-.67.02-1,.0508V16C22,8.115,19.0435,2,16.5,2S11,8.115,11,16v5H6v3a6.0067,6.0067,0,0,0,6,6h3A11.0125,11.0125,0,0,0,26,19V16ZM13,16h2V14H13.0728a25.8942,25.8942,0,0,1,.5654-4H16V8H14.2c.81-2.4058,1.8149-3.7715,2.3-3.9863.66.2919,2.2842,2.7036,3.0654,6.9863H18v2h1.8442A29.1625,29.1625,0,0,1,20,16v.4263A11.0554,11.0554,0,0,0,13.79,21H13ZM12,28a4.0045,4.0045,0,0,1-4-4V23h4.7639A10.9033,10.9033,0,0,0,12,27Zm12-9a9.01,9.01,0,0,1-9,9H14V27a9.01,9.01,0,0,1,9-9h1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Corner = /*#__PURE__*/React.forwardRef(function Corner(_ref78, ref) {
  var children = _ref78.children,
    _ref78$size = _ref78.size,
    size = _ref78$size === void 0 ? 16 : _ref78$size,
    rest = _objectWithoutProperties(_ref78, _excluded78);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H14V6H6v8H9V28h2V14h3V11H28ZM12,12H8V8h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Coronavirus = /*#__PURE__*/React.forwardRef(function Coronavirus(_ref79, ref) {
  var children = _ref79.children,
    _ref79$size = _ref79.size,
    size = _ref79$size === void 0 ? 16 : _ref79$size,
    rest = _objectWithoutProperties(_ref79, _excluded79);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "11.5",
    r: "1.5"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "20.5",
    cy: "15.5",
    r: "1.5"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "20.5",
    r: "1.5"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "11.5",
    cy: "16.5",
    r: "1.5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13v2H25.9492a9.9476,9.9476,0,0,0-2.2143-5.3213l1.4367-1.4365,1.4143,1.4145L28,8.2427,23.7578,4l-1.414,1.4141,1.414,1.414-1.437,1.4365A9.9464,9.9464,0,0,0,17,6.0508V4h2V2H13V4h2V6.0508A9.9464,9.9464,0,0,0,9.6792,8.2646L8.2422,6.8281l1.414-1.414L8.2422,4,4,8.2427l1.4141,1.414L6.8284,8.2422,8.2651,9.6787A9.9476,9.9476,0,0,0,6.0508,15H4V13H2v6H4V17H6.0508a9.9476,9.9476,0,0,0,2.2143,5.3213L6.8284,23.7578,5.4141,22.3433,4,23.7573,8.2422,28l1.414-1.4141-1.414-1.414,1.437-1.4365A9.9464,9.9464,0,0,0,15,25.9492V28H13v2h6V28H17V25.9492a9.9464,9.9464,0,0,0,5.3208-2.2138l1.437,1.4365-1.414,1.414L23.7578,28,28,23.7573l-1.4141-1.414-1.4143,1.4145-1.4367-1.4365A9.9476,9.9476,0,0,0,25.9492,17H28v2h2V13ZM16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cost = /*#__PURE__*/React.forwardRef(function Cost(_ref80, ref) {
  var children = _ref80.children,
    _ref80$size = _ref80.size,
    size = _ref80$size === void 0 ? 16 : _ref80$size,
    rest = _objectWithoutProperties(_ref80, _excluded80);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,16,23Zm0-12a5,5,0,1,0,5,5A5.0057,5.0057,0,0,0,16,11Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CostTotal = /*#__PURE__*/React.forwardRef(function CostTotal(_ref81, ref) {
  var children = _ref81.children,
    _ref81$size = _ref81.size,
    size = _ref81$size === void 0 ? 16 : _ref81$size,
    rest = _objectWithoutProperties(_ref81, _excluded81);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H22V15H10zM10 18H22V20H10z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6.4141,28.5859,5l-3.35,3.35A12.0812,12.0812,0,0,0,23.65,6.7637L27,3.4141,25.5859,2,21.9766,5.6094A11.9792,11.9792,0,0,0,5.6094,21.9766L2,25.5859,3.4141,27l3.35-3.35A12.0812,12.0812,0,0,0,8.35,25.2363L5,28.5859,6.4141,30l3.6093-3.6094A11.9792,11.9792,0,0,0,26.3906,10.0234ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cough = /*#__PURE__*/React.forwardRef(function Cough(_ref82, ref) {
  var children = _ref82.children,
    _ref82$size = _ref82.size,
    size = _ref82$size === void 0 ? 16 : _ref82$size,
    rest = _objectWithoutProperties(_ref82, _excluded82);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "23",
    r: "1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "20",
    r: "1"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "26",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "17",
    r: "1"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "29",
    r: "1"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "23",
    r: "1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Course = /*#__PURE__*/React.forwardRef(function Course(_ref83, ref) {
  var children = _ref83.children,
    _ref83$size = _ref83.size,
    size = _ref83$size === void 0 ? 16 : _ref83$size,
    rest = _objectWithoutProperties(_ref83, _excluded83);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V20.6182l-5-2.5-5,2.5V4H8V28H24V24h2v4A2.0027,2.0027,0,0,1,24,30ZM21,15.8818l3,1.5V4H18V17.3818Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Covariate = /*#__PURE__*/React.forwardRef(function Covariate(_ref84, ref) {
  var children = _ref84.children,
    _ref84$size = _ref84.size,
    size = _ref84$size === void 0 ? 16 : _ref84$size,
    rest = _objectWithoutProperties(_ref84, _excluded84);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "8",
    r: "2"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "18",
    r: "2"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,4,26.5859V2H2V28a2,2,0,0,0,2,2H30V28H5.4141ZM4,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Credentials = /*#__PURE__*/React.forwardRef(function Credentials(_ref85, ref) {
  var children = _ref85.children,
    _ref85$size = _ref85.size,
    size = _ref85$size === void 0 ? 16 : _ref85$size,
    rest = _objectWithoutProperties(_ref85, _excluded85);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22a4 4 0 10-4-4A4 4 0 0016 22zm0-6a2 2 0 11-2 2A2 2 0 0116 16zM14 6H18V8H14z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2.002,2.002,0,0,0,6,4V28a2.0023,2.0023,0,0,0,2,2H24a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,24,2ZM20,28H12V26a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm2,0V26a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v2H8V4H24V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Critical = /*#__PURE__*/React.forwardRef(function Critical(_ref86, ref) {
  var children = _ref86.children,
    _ref86$size = _ref86.size,
    size = _ref86$size === void 0 ? 16 : _ref86$size,
    rest = _objectWithoutProperties(_ref86, _excluded86);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
      d: "M12.887 11.4727a5.9936 5.9936 0 00-8.36-8.3594zM3.113 4.5273a5.9936 5.9936 0 008.36 8.3594z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M12.887 11.4727a5.9936 5.9936 0 00-8.36-8.3594zM3.113 4.5273a5.9936 5.9936 0 008.36 8.3594z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CriticalSeverity = /*#__PURE__*/React.forwardRef(function CriticalSeverity(_ref87, ref) {
  var children = _ref87.children,
    _ref87$size = _ref87.size,
    size = _ref87$size === void 0 ? 16 : _ref87$size,
    rest = _objectWithoutProperties(_ref87, _excluded87);
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
      d: "M13 13L3 13 3 3 13 13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L3 13 3 3 13 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Crop = /*#__PURE__*/React.forwardRef(function Crop(_ref88, ref) {
  var children = _ref88.children,
    _ref88$size = _ref88.size,
    size = _ref88$size === void 0 ? 16 : _ref88$size,
    rest = _objectWithoutProperties(_ref88, _excluded88);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20H23V9H12V7H23a2,2,0,0,1,2,2Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M9,23V2H7V7H2V9H7V23a2,2,0,0,0,2,2H23v5h2V25h5V23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CropGrowth = /*#__PURE__*/React.forwardRef(function CropGrowth(_ref89, ref) {
  var children = _ref89.children,
    _ref89$size = _ref89.size,
    size = _ref89$size === void 0 ? 16 : _ref89$size,
    rest = _objectWithoutProperties(_ref89, _excluded89);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M26,13a4.0045,4.0045,0,0,0,4-4V6H27a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,19,4H16V7a6.0066,6.0066,0,0,0,6,6h1V26H11V21h1a4.0045,4.0045,0,0,0,4-4V14H13a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,5,12H2v3a6.0066,6.0066,0,0,0,6,6H9v5H2v2H30V26H25V13Zm-1-3a2.002,2.002,0,0,1,2-2h1V9a2.002,2.002,0,0,1-2,2H25ZM11,18a2.002,2.002,0,0,1,2-2h1v1a2.002,2.002,0,0,1-2,2H11ZM9,19H8a4.0045,4.0045,0,0,1-4-4V14H5a4.0045,4.0045,0,0,1,4,4Zm14-8H22a4.0045,4.0045,0,0,1-4-4V6h1a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CropHealth = /*#__PURE__*/React.forwardRef(function CropHealth(_ref90, ref) {
  var children = _ref90.children,
    _ref90$size = _ref90.size,
    size = _ref90$size === void 0 ? 16 : _ref90$size,
    rest = _objectWithoutProperties(_ref90, _excluded90);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H10V30H2zM17 29a1 1 0 01-.7808-.3752L12.52 24H2V22H13a1 1 0 01.7808.3752l3.146 3.9322 5.2412-7.8621A1 1 0 0123.8 18.4L26.5 22H30v2H26a.9991.9991 0 01-.8-.4l-2.1523-2.8694-5.2159 7.824a.9986.9986 0 01-.7885.4443zM11 16V11h1a4.0045 4.0045 0 004-4V4H13a3.9779 3.9779 0 00-2.7468 1.1067A6.0034 6.0034 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.002 2.002 0 0113 6zM8 9A4.0045 4.0045 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCrossReference = /*#__PURE__*/React.forwardRef(function WatsonHealthCrossReference(_ref91, ref) {
  var children = _ref91.children,
    _ref91$size = _ref91.size,
    size = _ref91$size === void 0 ? 16 : _ref91$size,
    rest = _objectWithoutProperties(_ref91, _excluded91);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H15V26H11zM5 24H9V26H5zM23 24H27V26H23zM17 24H21V26H17zM9 22a4.92 4.92 0 014-2h6a5.22 5.22 0 014 2h2.3A6.87 6.87 0 0019 18H13a6.87 6.87 0 00-6.3 4zM24 28H26V30H24zM6 28H8V30H6zM16 16a7 7 0 117-7A7 7 0 0116 16zM16 4a5 5 0 00-5 5A5 5 0 0021 9 5 5 0 0016 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CrossTab = /*#__PURE__*/React.forwardRef(function CrossTab(_ref92, ref) {
  var children = _ref92.children,
    _ref92$size = _ref92.size,
    size = _ref92$size === void 0 ? 16 : _ref92$size,
    rest = _objectWithoutProperties(_ref92, _excluded92);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H10A2.0023,2.0023,0,0,0,8,4V7H4A2.0023,2.0023,0,0,0,2,9V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM10,4H28V7H10ZM28,14H20V9h8ZM10,21V16h8v5Zm8,2v5H10V23ZM8,21H4V16H8ZM18,9v5H10V9Zm2,7h8v5H20ZM8,9v5H4V9ZM4,23H8v5H4Zm16,5V23h8v5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Crossroads = /*#__PURE__*/React.forwardRef(function Crossroads(_ref93, ref) {
  var children = _ref93.children,
    _ref93$size = _ref93.size,
    size = _ref93$size === void 0 ? 16 : _ref93$size,
    rest = _objectWithoutProperties(_ref93, _excluded93);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859,6.5859A1.9862,1.9862,0,0,0,25.1719,6H17V2H15V12H6.8281a1.9862,1.9862,0,0,0-1.414.5859L2,16l3.4141,3.4141A1.9862,1.9862,0,0,0,6.8281,20H15V30h2V14h8.1719a1.9862,1.9862,0,0,0,1.414-.5859L30,10ZM6.8281,18l-2-2,2-2H15v4Zm18.3438-6H17V8h8.1719l2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CrowdReport = /*#__PURE__*/React.forwardRef(function CrowdReport(_ref94, ref) {
  var children = _ref94.children,
    _ref94$size = _ref94.size,
    size = _ref94$size === void 0 ? 16 : _ref94$size,
    rest = _objectWithoutProperties(_ref94, _excluded94);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CrowdReportFilled = /*#__PURE__*/React.forwardRef(function CrowdReportFilled(_ref95, ref) {
  var children = _ref95.children,
    _ref95$size = _ref95.size,
    size = _ref95$size === void 0 ? 16 : _ref95$size,
    rest = _objectWithoutProperties(_ref95, _excluded95);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0021,2.0021,0,0,1-2-2V10a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2v5a2.0021,2.0021,0,0,1-2,2H18.5352Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm6,13a2.0023,2.0023,0,0,1-2,2H18.5352L16.832,19.5547l-1.664-1.1094L17.4648,15H20V10H12v5h2v2H12a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Csv = /*#__PURE__*/React.forwardRef(function Csv(_ref96, ref) {
  var children = _ref96.children,
    _ref96$size = _ref96.size,
    size = _ref96$size === void 0 ? 16 : _ref96$size,
    rest = _objectWithoutProperties(_ref96, _excluded96);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM10 23H4a2.0023 2.0023 0 01-2-2V11A2.002 2.002 0 014 9h6v2H4V21h6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCU1 = /*#__PURE__*/React.forwardRef(function QCU1(_ref97, ref) {
  var children = _ref97.children,
    _ref97$size = _ref97.size,
    size = _ref97$size === void 0 ? 16 : _ref97$size,
    rest = _objectWithoutProperties(_ref97, _excluded97);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM27 21L27 9.01 22 9.01 22 11.01 25 11.01 25 21 22 21 22 23 30 23 30 21 27 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCU3 = /*#__PURE__*/React.forwardRef(function QCU3(_ref98, ref) {
  var children = _ref98.children,
    _ref98$size = _ref98.size,
    size = _ref98$size === void 0 ? 16 : _ref98$size,
    rest = _objectWithoutProperties(_ref98, _excluded98);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H5a2 2 0 01-2-2V15a2 2 0 012-2h5v2H5v6h5zM18 23H14a2 2 0 01-2-2V9h2V21h4V9h2V21A2 2 0 0118 23zM28 9H22v2h6v4H23v2h5v4H22v2h6a2 2 0 002-2V11A2 2 0 0028 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cube = /*#__PURE__*/React.forwardRef(function Cube(_ref99, ref) {
  var children = _ref99.children,
    _ref99$size = _ref99.size,
    size = _ref99$size === void 0 ? 16 : _ref99$size,
    rest = _objectWithoutProperties(_ref99, _excluded99);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM16,3.1577,26.0156,9,16,14.8423,5.9844,9ZM5,10.7412l10,5.833V28.2588L5,22.4258ZM17,28.2588V16.5742l10-5.833V22.4258Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CubeView = /*#__PURE__*/React.forwardRef(function CubeView(_ref100, ref) {
  var children = _ref100.children,
    _ref100$size = _ref100.size,
    size = _ref100$size === void 0 ? 16 : _ref100$size,
    rest = _objectWithoutProperties(_ref100, _excluded100);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7769,15.4785A8.64,8.64,0,0,0,16,10a8.64,8.64,0,0,0-7.7769,5.4785L8,16l.2231.5215A8.64,8.64,0,0,0,16,22a8.64,8.64,0,0,0,7.7769-5.4785L24,16ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5039,8.1362l-12-7a1,1,0,0,0-1.0078,0l-12,7A1,1,0,0,0,3,9V23a1,1,0,0,0,.4961.8638l12,7a1,1,0,0,0,1.0078,0l12-7A1,1,0,0,0,29,23V9A1,1,0,0,0,28.5039,8.1362ZM27,22.4258,16,28.8423,5,22.4258V9.5742L16,3.1577,27,9.5742Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Currency = /*#__PURE__*/React.forwardRef(function Currency(_ref101, ref) {
  var children = _ref101.children,
    _ref101$size = _ref101.size,
    size = _ref101$size === void 0 ? 16 : _ref101$size,
    rest = _objectWithoutProperties(_ref101, _excluded101);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyBaht = /*#__PURE__*/React.forwardRef(function CurrencyBaht(_ref102, ref) {
  var children = _ref102.children,
    _ref102$size = _ref102.size,
    size = _ref102$size === void 0 ? 16 : _ref102$size,
    rest = _objectWithoutProperties(_ref102, _excluded102);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4023,15.6426A4.9727,4.9727,0,0,0,23,12V11a5.0059,5.0059,0,0,0-5-5H17V3H15V6H10V26h5v3h2V26h2a5.0059,5.0059,0,0,0,5-5V20A4.9834,4.9834,0,0,0,21.4023,15.6426ZM12,8h6a3.0033,3.0033,0,0,1,3,3v1a3.0033,3.0033,0,0,1-3,3H12ZM22,21a3.0033,3.0033,0,0,1-3,3H12V17h7a3.0033,3.0033,0,0,1,3,3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyDollar = /*#__PURE__*/React.forwardRef(function CurrencyDollar(_ref103, ref) {
  var children = _ref103.children,
    _ref103$size = _ref103.size,
    size = _ref103$size === void 0 ? 16 : _ref103$size,
    rest = _objectWithoutProperties(_ref103, _excluded103);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20.5151c0-4.6152-3.78-5.1411-6.8171-5.563-3.31-.4609-5.1829-.86-5.1829-3.71C11,8.8491,13.5071,8,15.6538,8a6.7538,6.7538,0,0,1,5.5681,2.6279l1.5562-1.2558A8.6508,8.6508,0,0,0,17,6.0962V3H15V6.022c-3.6152.2192-6,2.26-6,5.22,0,4.73,3.83,5.2627,6.9075,5.69C19.16,17.3848,21,17.7744,21,20.5151,21,23.5474,17.8674,24,16,24c-3.4294,0-4.8782-.9639-6.2219-2.6279L8.2219,22.6279A8.4382,8.4382,0,0,0,15,25.9648V29h2V25.9551C20.7256,25.6509,23,23.6279,23,20.5151Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyEuro = /*#__PURE__*/React.forwardRef(function CurrencyEuro(_ref104, ref) {
  var children = _ref104.children,
    _ref104$size = _ref104.size,
    size = _ref104$size === void 0 ? 16 : _ref104$size,
    rest = _objectWithoutProperties(_ref104, _excluded104);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26c-3.6162,0-6.3328-2.2974-7.4456-6H19V18H9.1321A15.2782,15.2782,0,0,1,9,16c0-.33.01-.6641.0259-1H19V13H9.2371C9.8447,9.3525,11.81,6,17,6c3.8533,0,5.5315,1.6465,7.1282,4.4893l1.7436-.9786C24.2649,6.6484,22.0779,4,17,4,10.6448,4,7,8.374,7,16c0,7.0654,4.1121,12,10,12,5.0779,0,7.2649-2.6484,8.8718-5.5107l-1.7436-.9786C22.5315,24.3535,20.8533,26,17,26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyLira = /*#__PURE__*/React.forwardRef(function CurrencyLira(_ref105, ref) {
  var children = _ref105.children,
    _ref105$size = _ref105.size,
    size = _ref105$size === void 0 ? 16 : _ref105$size,
    rest = _objectWithoutProperties(_ref105, _excluded105);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M23,19a6.0066,6.0066,0,0,1-6,6H13V18.1079L21.2139,15V13L13,16.1079v-3L21.2139,10V8L13,11.1079V5H11v6.8647L8,13v2l3-1.1353v3L8,18v2l3-1.1353V27h6a8.0092,8.0092,0,0,0,8-8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyPound = /*#__PURE__*/React.forwardRef(function CurrencyPound(_ref106, ref) {
  var children = _ref106.children,
    _ref106$size = _ref106.size,
    size = _ref106$size === void 0 ? 16 : _ref106$size,
    rest = _objectWithoutProperties(_ref106, _excluded106);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4531,25A8.7775,8.7775,0,0,0,14,20a10.6,10.6,0,0,0-.18-2H22V16H13.2175c-.0842-.2109-.17-.4194-.2556-.624A9.8586,9.8586,0,0,1,12,11a4.792,4.792,0,0,1,5-5,6.1234,6.1234,0,0,1,5.2222,2.6279l1.5556-1.2558A8.11,8.11,0,0,0,17,4a6.7781,6.7781,0,0,0-7,7,11.65,11.65,0,0,0,1.0559,5H8v2h3.7729A8.209,8.209,0,0,1,12,20c0,2.5234-1.4858,5-3,5v2H24V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyRuble = /*#__PURE__*/React.forwardRef(function CurrencyRuble(_ref107, ref) {
  var children = _ref107.children,
    _ref107$size = _ref107.size,
    size = _ref107$size === void 0 ? 16 : _ref107$size,
    rest = _objectWithoutProperties(_ref107, _excluded107);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4H10V15H7v2h3v3H7v2h3v6h2V22h9V20H12V17h7a6.0067,6.0067,0,0,0,6-6V10A6.0067,6.0067,0,0,0,19,4Zm4,7a4.0045,4.0045,0,0,1-4,4H12V6h7a4.0045,4.0045,0,0,1,4,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyRupee = /*#__PURE__*/React.forwardRef(function CurrencyRupee(_ref108, ref) {
  var children = _ref108.children,
    _ref108$size = _ref108.size,
    size = _ref108$size === void 0 ? 16 : _ref108$size,
    rest = _objectWithoutProperties(_ref108, _excluded108);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M24,7V5H8V7h5.5a4.4906,4.4906,0,0,1,4.45,4H8v2h9.95A4.4906,4.4906,0,0,1,13.5,17H8v2.3452L17.6169,28l1.3379-1.4863L10.606,19H13.5a6.5041,6.5041,0,0,0,6.4746-6H24V11H19.9746A6.4719,6.4719,0,0,0,18.18,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyShekel = /*#__PURE__*/React.forwardRef(function CurrencyShekel(_ref109, ref) {
  var children = _ref109.children,
    _ref109$size = _ref109.size,
    size = _ref109$size === void 0 ? 16 : _ref109$size,
    rest = _objectWithoutProperties(_ref109, _excluded109);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M9,27H7V5h8a5.0057,5.0057,0,0,1,5,5V22H18V10a3.0033,3.0033,0,0,0-3-3H9Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H12V10h2V25h6a3.0033,3.0033,0,0,0,3-3V5h2V22A5.0057,5.0057,0,0,1,20,27Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyWon = /*#__PURE__*/React.forwardRef(function CurrencyWon(_ref110, ref) {
  var children = _ref110.children,
    _ref110$size = _ref110.size,
    size = _ref110$size === void 0 ? 16 : _ref110$size,
    rest = _objectWithoutProperties(_ref110, _excluded110);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14L28 12 23.045 12 24 5 22 5 20 23 17 8 15 8 12 23 10 5 8 5 8.955 12 4 12 4 14 9.227 14 9.636 17 4 17 4 19 9.909 19 11 27 13 27 16 12 19 27 21 27 22.091 19 28 19 28 17 22.364 17 22.773 14 28 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CurrencyYen = /*#__PURE__*/React.forwardRef(function CurrencyYen(_ref111, ref) {
  var children = _ref111.children,
    _ref111$size = _ref111.size,
    size = _ref111$size === void 0 ? 16 : _ref111$size,
    rest = _objectWithoutProperties(_ref111, _excluded111);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.271 5L22 5 16 16 10 5 7.729 5 13.794 16 8 16 8 18 15 18 15 21 8 21 8 23 15 23 15 27 17 27 17 23 24 23 24 21 17 21 17 18 24 18 24 16 18.206 16 24.271 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cursor_1 = /*#__PURE__*/React.forwardRef(function Cursor_1(_ref112, ref) {
  var children = _ref112.children,
    _ref112$size = _ref112.size,
    size = _ref112$size === void 0 ? 16 : _ref112$size,
    rest = _objectWithoutProperties(_ref112, _excluded112);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a1,1,0,0,1-.71-.29l-6.13-6.14-3.33,5a1,1,0,0,1-1,.44,1,1,0,0,1-.81-.7l-6-20A1,1,0,0,1,6.29,5l20,6a1,1,0,0,1,.7.81,1,1,0,0,1-.44,1l-5,3.33,6.14,6.13a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,23,28Zm0-2.41L25.59,23l-7.16-7.15,5.25-3.5L7.49,7.49l4.86,16.19,3.5-5.25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cursor_2 = /*#__PURE__*/React.forwardRef(function Cursor_2(_ref113, ref) {
  var children = _ref113.children,
    _ref113$size = _ref113.size,
    size = _ref113$size === void 0 ? 16 : _ref113$size,
    rest = _objectWithoutProperties(_ref113, _excluded113);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M27.34,12.06l-22-8A1,1,0,0,0,4.06,5.34l8,22A1,1,0,0,0,13,28h0a1,1,0,0,0,.93-.63l3.84-9.6,9.6-3.84a1,1,0,0,0,0-1.87Zm-10.71,4h0l-.4.16-.16.4h0L13,24.2,6.67,6.67,24.2,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cut = /*#__PURE__*/React.forwardRef(function Cut(_ref114, ref) {
  var children = _ref114.children,
    _ref114$size = _ref114.size,
    size = _ref114$size === void 0 ? 16 : _ref114$size,
    rest = _objectWithoutProperties(_ref114, _excluded114);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19.63,20.24,16l6.26-3.63a5,5,0,0,0-1.21-9.2A5.19,5.19,0,0,0,24,3a5,5,0,0,0-4.33,7.53,5,5,0,0,0,2.39,2.1l-3.82,2.21L4,6.6,3,8.34,16.24,16,3,23.68l1,1.74,14.24-8.26,3.82,2.21a5,5,0,0,0-2.39,2.1A5,5,0,0,0,24,29a5.19,5.19,0,0,0,1.29-.17,5,5,0,0,0,1.21-9.2ZM21.4,9.53a3,3,0,0,1,1.1-4.12,3,3,0,0,1,4.1,1.11,3,3,0,0,1-1.1,4.11h0A3,3,0,0,1,21.4,9.53Zm5.2,16a3,3,0,0,1-4.1,1.11,3,3,0,0,1-1.1-4.12,3,3,0,0,1,4.1-1.1h0A3,3,0,0,1,26.6,25.48Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthCutInHalf = /*#__PURE__*/React.forwardRef(function WatsonHealthCutInHalf(_ref115, ref) {
  var children = _ref115.children,
    _ref115$size = _ref115.size,
    size = _ref115$size === void 0 ? 16 : _ref115$size,
    rest = _objectWithoutProperties(_ref115, _excluded115);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H16V26H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var CutOut = /*#__PURE__*/React.forwardRef(function CutOut(_ref116, ref) {
  var children = _ref116.children,
    _ref116$size = _ref116.size,
    size = _ref116$size === void 0 ? 16 : _ref116$size,
    rest = _objectWithoutProperties(_ref116, _excluded116);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M19.05 13.7326L18.05 12 7.928 17.8457 6.9312 17.27a2.9524 2.9524 0 00.6672-.769A3 3 0 103.5 17.5986l2.428 1.4019L3.5 20.4023a3.0342 3.0342 0 103.4407.3223l.987-.5693L14.5914 24l1-1.7294-5.6634-3.27zM4.0344 15.26a1 1 0 11.4658.6069A.9929.9929 0 014.0344 15.26zM4.9988 22a1 1 0 11-.8645 1.5A1 1 0 014.9988 22zM17 26H21V28H17zM10 26H14V28H10z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H24V26h4V4H7V8H5V4A2.0023,2.0023,0,0,1,7,2H28a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,28,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCY = /*#__PURE__*/React.forwardRef(function QCY(_ref117, ref) {
  var children = _ref117.children,
    _ref117$size = _ref117.size,
    size = _ref117$size === void 0 ? 16 : _ref117$size,
    rest = _objectWithoutProperties(_ref117, _excluded117);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23H10a2 2 0 01-2-2V15a2 2 0 012-2h5v2H10v6h5zM24 9L22 9 20 16 18 9 16 9 19 18 19 23 21 23 21 18 24 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Cyclist = /*#__PURE__*/React.forwardRef(function Cyclist(_ref118, ref) {
  var children = _ref118.children,
    _ref118$size = _ref118.size,
    size = _ref118$size === void 0 ? 16 : _ref118$size,
    rest = _objectWithoutProperties(_ref118, _excluded118);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30a6 6 0 116-6A6.0069 6.0069 0 0125 30zm0-10a4 4 0 104 4A4.0045 4.0045 0 0025 20zM7 30a6 6 0 116-6A6.0069 6.0069 0 017 30zM7 20a4 4 0 104 4A4.0045 4.0045 0 007 20z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27H15V20.4139L9.5849 15a2.003 2.003 0 010-2.8292l4.5859-4.5859a2.0024 2.0024 0 012.8286 0L21.414 12H27v1.9993L20.5853 14l-5-5L11 13.5849l6 6zM21.5 8A3.5 3.5 0 1125 4.5 3.5042 3.5042 0 0121.5 8zm0-5A1.5 1.5 0 1023 4.5 1.5017 1.5017 0 0021.5 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QCZ = /*#__PURE__*/React.forwardRef(function QCZ(_ref119, ref) {
  var children = _ref119.children,
    _ref119$size = _ref119.size,
    size = _ref119$size === void 0 ? 16 : _ref119$size,
    rest = _objectWithoutProperties(_ref119, _excluded119);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H9a2 2 0 01-2-2V15a2 2 0 012-2h5v2H9v6h5zM24 9L16 9 16 11 22 11 16 21 16 23 24 23 24 21 18 21 24 11 24 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Dashboard = /*#__PURE__*/React.forwardRef(function Dashboard(_ref120, ref) {
  var children = _ref120.children,
    _ref120$size = _ref120.size,
    size = _ref120$size === void 0 ? 16 : _ref120$size,
    rest = _objectWithoutProperties(_ref120, _excluded120);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H26V26H24zM20 16H22V26H20zM11 26a5.0059 5.0059 0 01-5-5H8a3 3 0 103-3V16a5 5 0 010 10z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,9H14V4H28ZM12,4v7H4V4ZM4,28V13H28.0007l.0013,15Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DashboardReference = /*#__PURE__*/React.forwardRef(function DashboardReference(_ref121, ref) {
  var children = _ref121.children,
    _ref121$size = _ref121.size,
    size = _ref121$size === void 0 ? 16 : _ref121$size,
    rest = _objectWithoutProperties(_ref121, _excluded121);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM24 21H26V26H24zM20 16H22V26H20zM16 18H18V26H16z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.002,2.002,0,0,0,2,4V16H4V13H28.001l.001,15H16v2H28a2.0027,2.0027,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2ZM12,11H4V4h8Zm2,0V4H28l.0007,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Data_1 = /*#__PURE__*/React.forwardRef(function Data_1(_ref122, ref) {
  var children = _ref122.children,
    _ref122$size = _ref122.size,
    size = _ref122$size === void 0 ? 16 : _ref122$size,
    rest = _objectWithoutProperties(_ref122, _excluded122);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H28V8H15zM15 24H28V26H15zM4 15H17V17H4zM7 11a4 4 0 114-4A4 4 0 017 11zM7 5A2 2 0 109 7 2 2 0 007 5zM7 29a4 4 0 114-4A4 4 0 017 29zm0-6a2 2 0 102 2A2 2 0 007 23zM25 20a4 4 0 114-4A4 4 0 0125 20zm0-6a2 2 0 102 2A2 2 0 0025 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Data_2 = /*#__PURE__*/React.forwardRef(function Data_2(_ref123, ref) {
  var children = _ref123.children,
    _ref123$size = _ref123.size,
    size = _ref123$size === void 0 ? 16 : _ref123$size,
    rest = _objectWithoutProperties(_ref123, _excluded123);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H15V8H4zM18 6H28V8H18zM21 12H28V14H21zM11 12H18V14H11zM4 12H8V14H4zM4 18H28V20H4zM4 24H21V26H4zM24 24H28V26H24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataBase = /*#__PURE__*/React.forwardRef(function DataBase(_ref124, ref) {
  var children = _ref124.children,
    _ref124$size = _ref124.size,
    size = _ref124$size === void 0 ? 16 : _ref124$size,
    rest = _objectWithoutProperties(_ref124, _excluded124);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M24,3H8A2,2,0,0,0,6,5V27a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V5A2,2,0,0,0,24,3Zm0,2v6H8V5ZM8,19V13H24v6Zm0,8V21H24v6Z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "8",
    r: "1"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "16",
    r: "1"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "24",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var DataBaseAlt = /*#__PURE__*/React.forwardRef(function DataBaseAlt(_ref125, ref) {
  var children = _ref125.children,
    _ref125$size = _ref125.size,
    size = _ref125$size === void 0 ? 16 : _ref125$size,
    rest = _objectWithoutProperties(_ref125, _excluded125);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread2({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H12V10H7zM7 12H12V14H7zM7 16H12V18H7zM20 8H25V10H20zM20 12H25V14H20zM20 16H25V18H20z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2.0023,2.0023,0,0,0,2,6V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,28,4ZM4,6H15V28H4ZM17,28V6H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
export { ClosedCaption, ClosedCaptionAlt, ClosedCaptionFilled, Cloud, CloudAlerting, CloudApp, CloudAuditing, CloudCeiling, CloudDataOps, CloudDownload, CloudFoundry_1, CloudFoundry_2, CloudLogging, CloudMonitoring, CloudOffline, CloudRegistry, CloudSatellite, CloudSatelliteConfig, CloudSatelliteLink, CloudSatelliteServices, CloudServiceManagement, CloudServices, CloudUpload, Cloudy, Code, CodeHide, CodeReference, CodeSigningService, Cognitive, Collaborate, CollapseAll, CollapseCategories, ColorPalette, ColorSwitch, Column, ColumnDelete, ColumnDependency, ColumnInsert, Commit, CommunicationUnified, Compare, Compass, Concept, ConditionPoint, ConditionWaitPoint, Connect, ConnectRecursive, ConnectReference, ConnectSource, ConnectTarget, ConnectionReceive, ConnectionSend, ConnectionSignal, ConnectionSignalOff, ConnectionTwoWay, Construction, ContainerRegistry, ContainerServices, ContainerSoftware, ContentDeliveryNetwork, ContentView, Continue, ContinueFilled, ContinuousDeployment, ContinuousIntegration, Contrast, ConvertToCloud, Cookie, Copy, CopyFile, CopyLink, Corn, Corner, Coronavirus, Cost, CostTotal, Cough, Course, Covariate, Credentials, Critical, CriticalSeverity, Crop, CropGrowth, CropHealth, CrossTab, Crossroads, CrowdReport, CrowdReportFilled, Csv, Cube, CubeView, Currency, CurrencyBaht, CurrencyDollar, CurrencyEuro, CurrencyLira, CurrencyPound, CurrencyRuble, CurrencyRupee, CurrencyShekel, CurrencyWon, CurrencyYen, Cursor_1, Cursor_2, Cut, CutOut, Cyclist, Dashboard, DashboardReference, DataBase, DataBaseAlt, Data_1, Data_2, QCU1, QCU3, QCY, QCZ, QComposerEdit, WatsonHealthCobbAngle, WatsonHealthContourDraw, WatsonHealthContourEdit, WatsonHealthContourFinding, WatsonHealthCrossReference, WatsonHealthCutInHalf };